import { CdpEuiccProfileSetActiveResponse } from "../app/shared/models/layout/cdp/euicc/profile/set_active/CdpEuiccProfileSetActive";

export function response(): CdpEuiccProfileSetActiveResponse {
    return {
        cmd: {
            success: true
        }
    }
}
